<div class="cm-row">
  @for (tab of actionTabs; track tab) {
    @if (tab?.hasTopLine) {
      <hr style="width: 100%" />
    }
    @if (!tab.subTabs) {
      <a
        class="tab-item"
        [class.disabled]="tab.disabled"
        [routerLink]="tab.disabled ? 'not-found' : tab.route"
        [queryParams]="tab.queryParams"
        [routerLinkActive]="tab.activeFn ? '' : 'active'"
        [ngClass]="{'active': tab.activeFn && tab.activeFn()}"
        (click)="tab.onClick ? tab.onClick() : ''"
        >
        <span [class]="tab.cssClass">{{ tab.label }}</span>
      </a>
    }
    @if (tab.subTabs) {
      <a class="text-tab-item">
        <span>{{ tab.label }}</span>
      </a>
    }
    <div class="sub-tabs-block">
      @for (subTab of tab.subTabs; track subTab) {
        <div class="d-flex align-items-center">
          <a
            class="sub-tab-item"
            [class.disabled]="subTab.disabled"
            [routerLink]="subTab.route"
            [queryParams]="subTab.queryParams"
            [routerLinkActive]="subTab.activeFn ? '' : 'active'"
            [ngClass]="{'active': subTab.activeFn && subTab.activeFn()}"
            (click)="subTab.onClick ? subTab.onClick() : ''"
            >
            <span>{{ subTab.label }}</span>
          </a>
          @if (subTab.icon && !subTab.disabled && (subTab.icon.visibility ?? true)) {
            <i
              class="material-icons {{ subTab.icon.type }}"
              id="atqa-hearing-delete-icon"
              (click)="subTab.icon.onClick ? subTab.icon.onClick() : ''"
              style="margin: 0 3px"
            >{{ subTab.icon.type }}</i>
          }
        </div>
      }
    </div>
  }
</div>

